function getKey(name) {
    const regExp = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)');
    return decodeURIComponent((regExp.exec(location.href) || [undefined, ""])[1].replace(/\+/g, '%20')) || null;
}

export {getKey};